import { ServiceType } from 'app/core/service-type.model';

export interface Application {
  account: string;
  binding: Binding;
  clone?: {
    progress: number;
    status: string;
  };
  dataLiveTime: string;
  id: string;
  isCustomized: boolean;
  isDeleted: boolean;
  name: string;
  owner: string;
  project: string;
  token: string;
  type: ServiceType;
  tenant?: string;
}

export enum ApplicationCloneStatus {
  Added = 'Added',
  Cancelled = 'Cancelled',
  Copied = 'Copied',
  Error = 'Error',
  Processing = 'Processing'
}

export interface ApplicationCredentials {
  id: string;
  token: string;
}

export interface Binding {
  id: string;
  tenant: string;
  project: string;
  user: string;
  password: string;
  isRealtime?: boolean;
}

export interface BindingRequest {
  id: string;
  tenant: string;
  project: string;
  user: string;
  password: string;
  is_realtime?: boolean;
}

export interface UsageLimit {
  limit: number;
  from: Date;
  to: Date;
}

export function authentication(application: Application): string {
  const credentials = `${application.id}:${application.token}`;
  return `Basic ${btoa(encodeURI(credentials))}`;
}
